import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M5.268 4H4v9h8V4h-1.268C10.387 4.598 9.74 5 9 5H7c-.74 0-1.387-.402-1.732-1zm5.464-2H12c1.105 0 2 .895 2 2v9c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h1.268C5.613 1.402 6.26 1 7 1h2c.74 0 1.387.402 1.732 1zM7 2.6c-.22 0-.4.18-.4.4 0 .22.18.4.4.4h2c.22 0 .4-.18.4-.4 0-.22-.18-.4-.4-.4H7z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M7.05 5H6v15h12V5h-1.05c-.232 1.141-1.24 2-2.45 2h-5c-1.21 0-2.218-.859-2.45-2zm9.45-2H18c1.105 0 2 .895 2 2v15c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h1.5c.456-.607 1.182-1 2-1h5c.818 0 1.544.393 2 1zm-7 1c-.276 0-.5.224-.5.5s.224.5.5.5h5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-5z"
        />
      </g>
    </svg>
  ),
};
